angular.module('impactx.productstock').controller('EditAllProductStockController', [
    '$scope',
    '$mdDialog',
    'data',
    'themeFactory',
    'trns',
    'dataGen',
    '$route',
    'ToastService',
    'TranslationService',
    EditAllProductStockController]);

function EditAllProductStockController($scope, $mdDialog, data, themeFactory, trns, dataGen, $route, ToastService, TranslationService)
{
    $scope.data = data;
    $scope.trns = trns;
    $scope.theme = themeFactory.getTheme();

    this.cancel = function ()
    {
        // remove orderstop from products which had no orderstop before editing
        dataGen.postAsForm($scope, {ids: $scope.data.hadNoOrderStops}, "/productstock/orderstop/remove");

        $mdDialog.cancel();
    };

    this.answer = function (removeOrderStop)
    {
        if (removeOrderStop) {
            $scope.data.orderStop.value = false;
        }

        dataGen.postAsForm($scope, {data: $scope.data}, "/productstock/save/all").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $mdDialog.hide();
        });
    };

    this.addInterval = function () {
        $scope.data.intervals.push(JSON.parse(JSON.stringify($scope.data.templateInterval)));
    };

    this.removeInterval = function (index) {
        $scope.data.intervals.splice(index, 1);
    };
}